import { FormControl } from '@chakra-ui/react';
import { useCallback } from 'react';
import { CreatorListDrawer } from '~/components/CreatorListDrawer';
import { CONTENT_SEARCH_PARAMS } from '~/hooks/useContentSearch';

import { IContentSearchComponentProps } from '../ContentSearchFilter.types';

export const ContentSearchFilterCreator: React.FC<
  IContentSearchComponentProps
> = ({
  filters: { creator: creatorId = '' },
  onChange,
  trackId,
  order,
  isDisabled,
}) => {
  const handleChange = useCallback(
    (creatorId: string) => {
      onChange({
        [CONTENT_SEARCH_PARAMS.creator]: creatorId,
      });
    },
    [onChange],
  );

  return (
    <FormControl
      display="inline-flex"
      width="auto"
      alignItems="center"
      order={order}
      pointerEvents={isDisabled ? 'none' : 'auto'}
    >
      <CreatorListDrawer
        onFilter={handleChange}
        defaultSelectedCreatorId={creatorId}
        trackId={trackId}
      />
    </FormControl>
  );
};
